import { createStyles, makeStyles, Typography } from "@material-ui/core";
import InboxIcon from "@material-ui/icons/Inbox";
import React from "react";

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      marginTop: "5rem",

      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      alignItems: "center",
    },
  })
);

const NoData: React.FC = ({ children }) => {
  const classes = useStyles();
  return (
    <div className={classes.box}>
      <InboxIcon fontSize="large" />
      <Typography align="center" variant="h6">
        {children}
      </Typography>
    </div>
  );
};

export default NoData;
